import { OrderBy, QueryResult } from '@shared/types';
import { FirestoreDocument } from '../../types';
import { inferFieldsFromDocuments } from '../../utils';

function ensureDocumentIdField(fields: string[]): string[] {
  return Array.from(new Set(['__id__', ...fields]));
}

export function getDisplayDocuments(
  queryResults: QueryResult | null,
  searchResults: FirestoreDocument[] | null,
  documents: FirestoreDocument[]
): FirestoreDocument[] {
  if (queryResults) return queryResults.documents;
  if (searchResults) return searchResults;
  return documents;
}

export function getAvailableFields(documents: FirestoreDocument[]): string[] {
  return ensureDocumentIdField(inferFieldsFromDocuments(documents));
}

export function isInspectorOpen(
  documentId: string | null,
  currentDocument: FirestoreDocument | null,
  selectedDocument: FirestoreDocument | null
): boolean {
  return !!documentId && (!!currentDocument || !!selectedDocument);
}

/** Map query builder __name__ to table __id__ and vice versa for display. */
export function getTableSortState(
  queryResults: QueryResult | null,
  queryOrderBy: OrderBy[],
  safeSortState: OrderBy | null
): OrderBy | null {
  if (queryResults && queryOrderBy.length > 0) {
    const first = queryOrderBy[0];
    return {
      field: first.field === '__name__' ? '__id__' : first.field,
      direction: first.direction,
    };
  }
  return safeSortState;
}

export function shouldShowConnectionSetup(
  connectionId: string | null,
  oauthStatus: { status: string } | null | undefined
): boolean {
  return !connectionId && oauthStatus?.status === 'connected';
}

export function shouldShowConnectionBannerOnly(
  connectionId: string | null,
  _oauthStatus: { status: string } | null | undefined
): boolean {
  return !connectionId;
}

export function hasCollection(collectionName: string | null): collectionName is string {
  return !!collectionName;
}

export function normalizeOrderByForQueryBuilder(sortState: OrderBy): OrderBy {
  const field = sortState.field === '__id__' ? '__name__' : sortState.field;
  return { field, direction: sortState.direction };
}
